import { PatientGroup, PatientGroupFilterParam } from './PatientGroupField.types';

export const FILTER_SEPARATOR = ',';

export const getPatientGroupsFilterSearchParamValue = (patientGroups: PatientGroup[]): PatientGroupFilterParam => {
   return patientGroups.map(({ id }) => id).join(FILTER_SEPARATOR);
};

export const getPatientGroupFromSearchParam = (
   searchParamValue: number,
   patientGroups: PatientGroup[]
): PatientGroup | null => {
   return patientGroups.find(({ id }) => searchParamValue === id) ?? null;
};

export const mapPatientGroupFilterToPatientGroupIds = (patientGroupFilter: string | null): number[] => {
   return (patientGroupFilter?.split(FILTER_SEPARATOR) ?? []).reduce<number[]>((acc, currentId) => {
      if (currentId) {
         acc.push(Number(currentId));
      }

      return acc;
   }, []);
};
